var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Divider, Grid, IconButton, Stack, Typography, } from "@mui/material";
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRetrievePlayerFeed } from "../api/FeedApiProivder";
import { useRetrieveLeaguesByPlayerId } from "../api/LeagueApiProvider";
import { useDeletePlayer, useRetrieveTeamsByPlayerId, useRetrieveUserPlayerPermissions, } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { Feed } from "../feed/Feed";
import { LeaguesCard } from "../leagues/LeaguesCard";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { TeamsCard } from "../teams/TeamsCard";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { playerDisplayName } from "./PlayerDisplayNameLink";
import { PlayerStatsCard } from "./PlayerStatsCard";
import { PlayerView } from "./PlayerView";
export var PlayerPage = function (_a) {
    var _b;
    var player = _a.player, canViewTeams = _a.canViewTeams, canModify = _a.canModify;
    var navigate = useNavigate();
    var _c = __read(React.useState(false), 2), showDelete = _c[0], setShowDelete = _c[1];
    var _d = useRetrieveUserPlayerPermissions({ playerId: player.id }), userPlayerPermissions = _d.data, userPlayerPermissionsIsLoading = _d.isLoading, userPlayerPermissionsError = _d.error;
    var _e = useRetrieveTeamsByPlayerId({ playerId: player.id }), _f = _e.data, teams = _f === void 0 ? [] : _f, teamsIsLoading = _e.isLoading, teamsError = _e.error;
    var teamIds = (teams === null || teams === void 0 ? void 0 : teams.map(function (team) { return team.id; })) || [];
    var mutation = useDeletePlayer({
        id: player.id,
        teamIds: teamIds,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/");
        },
        onError: function () { },
    });
    var _g = useContext(UserContext), contextUser = _g.user, isContextUserLoading = _g.loading;
    var isOwnProfile = (contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk) === ((_b = player.user) === null || _b === void 0 ? void 0 : _b.pk);
    var _h = useRetrieveLeaguesByPlayerId({ playerId: player.id }), _j = _h.data, leagues = _j === void 0 ? [] : _j, leaguesIsLoading = _h.isLoading, leaguesError = _h.error;
    var _k = useRetrievePlayerFeed({ player: player, limit: 10 }), feed = _k.data, isFeedLoading = _k.isLoading, feedError = _k.error, fetchNextPage = _k.fetchNextPage, hasNextPage = _k.hasNextPage, isFetchingNextPage = _k.isFetchingNextPage;
    if (userPlayerPermissionsError) {
        return _jsx(ErrorView, { error: userPlayerPermissionsError });
    }
    if ((teamsIsLoading && canViewTeams) ||
        leaguesIsLoading ||
        mutation.isLoading ||
        userPlayerPermissionsIsLoading ||
        isFeedLoading ||
        isContextUserLoading) {
        return _jsx(Loading, {});
    }
    if (!player ||
        teamsError ||
        leaguesError ||
        feedError ||
        (!teams && canViewTeams) ||
        !userPlayerPermissions ||
        !feed) {
        return _jsx(ErrorView, { error: teamsError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete player. Please try again." }), _jsx(DeleteDialog, { open: showDelete, onCancel: function () { return setShowDelete(false); }, title: "Delete ".concat(playerDisplayName(player), "?"), onConfirm: function () { return mutation.mutate(); }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsxs(Grid, { item: true, xs: 10, children: [_jsx(PlayerView, { player: player }), _jsx(Typography, { variant: "body2", fontStyle: "italic", mt: 1, children: player.bio })] }), _jsx(Grid, { item: true, xs: 2, children: player.externalUser && canModify && (_jsxs(Stack, { direction: "row", spacing: 1, children: [_jsx(IconButton, { "aria-label": "edit", children: _jsx(Link, { to: "/external-users/".concat(player.externalUser.id, "/update/"), children: _jsx(EditIcon, {}) }) }), !player.user && (_jsx(IconButton, { "aria-label": "delete", disabled: mutation.isLoading, onClick: function () {
                                        setShowDelete(true);
                                    }, children: _jsx(DeleteIcon, {}) }))] })) })] }), _jsx(Divider, { sx: { margin: "20px" } }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 4, children: _jsx(PlayerStatsCard, { player: player, canModify: canModify }) }), _jsxs(Grid, { item: true, xs: 12, md: 5, sx: { order: { xs: 3, md: 2 } }, children: [_jsx(Typography, { variant: "h6", children: "Latest Activity" }), _jsx(Feed, { feed: feed, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isFetchingNextPage: isFetchingNextPage })] }), _jsxs(Grid, { item: true, xs: 12, md: 3, sx: { order: { xs: 2, md: 3 } }, children: [_jsx(TeamsCard, { teams: teams
                                    .filter(function (team) { var _a; return !!team.manager || ((_a = team.players) === null || _a === void 0 ? void 0 : _a.includes(player.id)); })
                                    .sort(function (a, b) { return a.name.localeCompare(b.name); }), isOwnProfile: isOwnProfile }), _jsx(Box, { sx: { mt: 2 }, children: _jsx(LeaguesCard, { leagues: leagues, isOwnProfile: isOwnProfile }) })] })] })] }));
};
